<template lang="html">
	<wizard-screen
		:completed="false"
		panel-class="omapi-panel__welcome"
		content-class="omapi-text-center"
		:nav-prev="false"
		:nav-next="false"
	>
		<h2>Welcome to the OptinMonster Setup Wizard!</h2>
		<common-alerts id="om-connect-alerts" :alerts="alerts" />

		<div class="omapi-happy-text">
			You're just minutes away from getting more subscribers, leads and sales from your website. Experience the
			full power of OptinMonster today!
		</div>
		<div>
			<core-button
				v-if="!isLoading"
				ref="toFocus"
				href="#"
				class="omapi-wizard-forward"
				size="monster"
				color="green"
				@click.prevent="$bus.$emit('onboardingNextPage')"
			>
				New? Claim Your Free Account
			</core-button>
		</div>
		<div v-if="!userId">
			<core-connect-button
				:output-errors="false"
				:arrow="false"
				:refresh-after="false"
				type="secondary"
				size="monster"
				class="omapi-wizard-connect-existing"
				@onSuccess="afterConnect"
			>
				Connect Your Existing Account
			</core-connect-button>
		</div>

		<template #after-card>
			<wizard-exit link-class="omapi-link-arrow-before"> Go back to the dashboard </wizard-exit>
		</template>
	</wizard-screen>
</template>

<script lang="js">
import { mapGetters, mapState } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	data () {
		return {
			redirectLoading : false,
		}
	},
	computed : {
		...mapState([ 'error', 'alerts' ]),
		...mapGetters([ 'userId' ]),
		isLoading () {
			return this.redirectLoading || this.$store.getters.isLoading('connect')
		},
	},
	mounted () {
		this.$nextTick(() => {
			const getFocusRef = (refs) => {
				while (refs.toFocus && refs.toFocus.$refs) {
					refs = refs.toFocus.$refs
				}

				return refs.toFocus
			}
			this.$nextTick(() => {
				const el = getFocusRef(this.$refs)
				if (el && el.focus) {
					el.focus()
				}
			})
		})
	},
	methods : {
		afterConnect () {
			this.redirectLoading = true
			this.$store.commit('addAlert', {
				message : 'Site connected successfully!',
				type    : 'success',
			})
			setTimeout(() => {
				this.$store.commit('clearAlerts')
				this.$store.commit('addAlert', {
					message : 'Reloading, please wait...',
					type    : 'success',
				})

				const prev = this.$router.getPreviousRoute()
				const prevUrl = prev.name ? (prev.fullPath || prev.path) : false

				if (!prevUrl) {
					this.$router.push({ name: 'dashboard' })
				}

				setTimeout(() => {
					if (prevUrl) {
						window.location.href = prevUrl
					} else {
						window.location.reload()
					}
				}, 200)
			}, 1500)
		},
	},
};
</script>
<style scoped lang="scss">
.omapi-panel__welcome {
	a.omapi-wizard-forward,
	button.omapi-wizard-forward {
		margin-bottom: 20px;
	}
}
</style>
